
const MiddleEastImmersionOverview = {
  Dubai: {
    programHighlights: [
      { id: 1, title: "GIP UAE", description: "Dubai + Sharjah" },
      { id: 2, title: "Duration", description: "14 days(5 days vertual + 9 days onsite)" },
      {
        id: 3,
        title: "University",
        description: "Rochester Institute of Technology (RIT), Dubai",
      },
      {
        id: 4,
        title: "Company Visits",
        description: [
          "Explore Sharjah's hub for new-age companies",
          "Technology & Finance: The Hub of Finance in Dubai",
          "Dubai Electricity & Water Authority and one of the world’s largest solar parks.",
        ].join("\n"),
      },
      {
        id: 5,
        title: "Cultural Exploration ",
        description: [
          "Introduction to Arabic Language",
          "In-depth Arabic Cultural Tour",
        ].join("\n"),
      },
      {
        id: 6,
        title: " Networking Opportunities  ",
        description: [
          " Networking events with Dubai business leaders.",
          "Participation in expert panels and workshops on launching businesses in international markets.",
        ].join("\n"),
      },
      {
        id: 7,
        title: "Academic Learning",
        description: [
          " Hands-on AI projects and business challenge competitions aligned with industry problems across various domains. ",
          "University-level workshops & sessions. ",
        ].join("\n"),
      },
    ],
   
  },
};

const SouthEastAsiaImmersionOverview = {
  Malaysia: {
    programHighlights: [
      { id: 1, title: "GIP Malaysia", description: "Malaysia" },
      { id: 2, title: "Duration", description: "5 Days (onsite)" },
      {
        id: 3,
        title: "University",
        description:
          "University Tun Husn Malaysia / University of Wollongong Malaysia",
      },
      {
        id: 4,
        title: "Company Visit",
        description:
          "Explore leading Malaysian industries to understand the application of academic knowledge in fields like finance, healthcare, and technology.",
      },
    ],
  
  },
  Thailand: {
    programHighlights: [
      { id: 1, title: "Innovation Camp on AI in Thailand ", description: "" },
      { id: 2, title: "Duration", description: "9 Days" },
      {
        id: 3,
        title: "University",
        description: "Asian Institute of Technology, Pathumthani, Thailand",
      },
      {
        id: 4,
        title: "Innovation lab visits",
        description: [
          "Explore leading industries in finance/healthcare/technology to understand real-world AI applications.",
          " Field trips to iconic sites in Bangkok.",
          " Experience traditional Thai culture, including a live Muay Thai event.",
        ].join("\n"),
      },
      {
        id: 5,
        title: "Cultural experience",
        description: [
          "Field trips to iconic sites in Bangkok ",
          "Experience traditional Thai culture, including a live Muay Thai event",
        ].join("\n"),
      },
      { id: 6, title: "Start up Gateway", description: "" },
      { id: 7,
         title: "Networking Opportunities",
         description: [
          "Connect with academic mentors, corporate executives, and international peers ",
          "Participate in interactive discussions and collaborative activities ",
        ].join("\n"),
      },
    ],

   
  },
};

const EuropeImmersionOverview = {
  France: {
    programHighlights: [
      { id: 1, title: "GIP France", description: "" },
      { id: 2, title: "Duration", description: "14 Days" },
      {
        id: 3,
        title: "University",
        description:
          " Aivancity, School of Artificial Intelligence and Data Science",
      },
      {
        id: 4,
        title: "Company Visit",
        description: " ",
      },
      {
        id: 5,
        title: "Cultural experience",
        description: " ",
      },
      {
        id: 6,
        title: "Start up Gateway",
        description: " ",
      },
      {
        id: 7,
        title: "Networking Opportunities",
        description: " ",
      },
      {
        id: 8,
        title: "Academic Learning",
        description: " ",
      },
    ],
  
  },
  Germany: {
    programHighlights: [
      { id: 1, title: "GIP Germany ", description: "" },
      { id: 2, title: "Duration", description: "14 Days" },
      {
        id: 3,
        title: "University",
        description: "Technical University Berlin",
      },
      {
        id: 4,
        title: "Company visits",
        description: " ",
      },
      {
        id: 5,
        title: "Cultural experience",
        description: "",
      },
      { id: 6, title: "Start up Gateway", description: "" },
      { id: 7,
         title: "Networking Opportunities",
         description: " ",
      },
      { id: 8,
         title: "Academic Learning",
         description: " ",
      },
    ],

   
  },
};
const NorthAmericaImmersionOverview = {};


export {
  MiddleEastImmersionOverview,
  SouthEastAsiaImmersionOverview,
  EuropeImmersionOverview,
  NorthAmericaImmersionOverview,
};
